module.exports = __webpack_public_path__ + "img/link-more.04507cf0.svg";